export default {
    getDepartmentList: '/auth/dept/pageDept', //表格查询获取部门列表
  };
  


// WEBPACK FOOTER //
// ./src/api/deptDetail.js